/**
 * URL設定管理ファイル
 * 
 * アプリケーション全体で使用するベースURLとAPIのURLを
 * 環境変数、動的生成、フォールバックの組み合わせで安全に取得する
 */

/**
 * アプリケーションのベースURLを取得
 * 
 * 優先順位:
 * 1. 環境変数 REACT_APP_URL
 * 2. ブラウザの window.location.origin (動的生成)
 * 3. フォールバック値 (環境別)
 * 
 * @returns {string} ベースURL
 */
export const getBaseUrl = (): string => {
  // 緊急修正: 環境変数が正しく読み込まれていないため、ハードコード対応
  console.log('🔧 getBaseUrl called - env value:', process.env.REACT_APP_URL);
  
  // 1. 環境変数優先
  const envUrl = process.env.REACT_APP_URL;
  if (envUrl && envUrl.trim() !== '' && !envUrl.includes('8081')) {
    return envUrl.trim();
  }

  // 2. ブラウザ環境では動的生成
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    console.log('🔧 Using window.location.origin:', origin);
    return origin;
  }

  // 3. フォールバック（SSR環境など）
  return process.env.NODE_ENV === 'production'
    ? 'https://photomemorial.com'
    : 'http://localhost:3000';  
};

/**
 * APIのベースURLを取得
 * 
 * 優先順位:
 * 1. 環境変数 REACT_APP_API_URL
 * 2. getBaseUrl() の結果
 * 
 * @returns {string} APIベースURL
 */
export const getApiBaseUrl = (): string => {
  // For local development, always point to the Spring Boot server on port 8081
  if (process.env.NODE_ENV !== 'production') {
    return 'http://localhost:8081';
  }

  const baseUrl = getBaseUrl();
  
  // API専用設定がある場合は優先
  // const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrl = process.env.REACT_APP_URL;
  if (apiUrl && apiUrl.trim() !== '') {
    return apiUrl.trim();
  }
  return baseUrl;
};